// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles__tag--2bjqr","button":"styles__button--4lUg8","icon":"styles__icon--3s1Bp","large":"styles__large--2qRvY"};